import { Module } from '@nestjs/common';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { RawMaterialGrnModule } from './raw-material-grn/raw-material-grn.module';
import { IndentModule } from './indent/indent.module';
import { TypeOrmModule } from '@nestjs/typeorm';
import appSettings from 'apps/services/config';
import { Indent } from './indent/indent.entity';
import { Grn } from './raw-material-grn/raw-material-grn.entity';
import { HaverstReport } from './indent/harvest-report.entity';
import { RmVehicleInspection } from './raw-material-grn/rm-vehicle-inspection.entity';
import { RmEvaluation } from './raw-material-grn/rm-evaluation.entity';
import { RmEvaluationSamples } from './raw-material-grn/rm-evaluation-samples.entity';
import { IndentItems } from './indent/indent-items.entity';
import { GrnItems } from './raw-material-grn/raw-material-grn-items.entity';
import { RmIndentQtyLimitModule } from './rm-indent-qty-limit/rm-indent-qty-limit.module';
import { RmIndentQtyLimit } from './rm-indent-qty-limit/rm-indent-qty-limit.entity';
import { RMReWeighingEntity } from './indent/rm-re-weighing/rm-re-weighing.entity';
import { GrnItemDefects } from './raw-material-grn/grn-item-defects.entity';
import { RmCountRanges } from './raw-material-grn/rm-count-pricelist-entity';
import { RmAntiBioticsTest } from './raw-material-grn/rm-antibiotics-report.entity';
import { RmCountPriceListModule } from './rm-count-price-list copy/rm-count-pricelist-module';
import { RmCountPriceListLogsEntity } from './rm-count-price-list copy/rm-count-pricelist-logs.entity';
import { RmRates } from './rm-count-price-list copy/rm-rates-entity';
import { RmInvoice } from './raw-material-grn/raw-materail-grn-invoice.entity';
import { BaleModule } from './bale-generation/bale.module';
import { BaleInfo } from './bale-generation/bale-info.entity';
import { BaleItems } from './bale-generation/bale-items.entity';
import { WorkOrderModule } from './work-order-generation/work-order.module';
import { WorkOrderInfo } from './work-order-generation/work-order.entity';
import { QaqcModule } from './qaqc/qaqc.module';
import { QAQCFibreAnalysisEntity } from './qaqc/entities/qaqc-fibre-analysis.entity';
import { QAQCFibreLabAnalysisEntity } from './qaqc/entities/qaqc-fibre-lab-analysis.entity';
import { WorkOrderItems } from './work-order-generation/work-order-items.entity';
import { ActualBaleQtyLogs } from './bale-generation/act-bale-qty-entity';
import { ProductCountEntity } from './rm-count-price-list copy/product-count-entity';
import { SkuPrice } from './rm-count-price-list copy/sku-price-entity';
import { SkuPriceLogs } from './rm-count-price-list copy/sku-price-logs-entity';
import { ProductionInventory } from 'apps/services/production/src/app/operations-track/entities/production-inventory.entity';
import { QAQCProductCountsEntity } from './qaqc/entities/qaqc-product-counts-entity';
@Module({
  imports: [
    TypeOrmModule.forRoot({
      type: 'mysql',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.rm_procure_db,
      entities: [
        Indent, IndentItems, Grn, HaverstReport, RmIndentQtyLimit, RmVehicleInspection, RmEvaluation, RmEvaluationSamples, RmAntiBioticsTest
        , GrnItems, RMReWeighingEntity, GrnItemDefects,RmCountRanges,RmCountPriceListLogsEntity,RmRates,RmInvoice,BaleInfo,BaleItems,WorkOrderInfo,WorkOrderItems,ActualBaleQtyLogs, ProductCountEntity, SkuPrice, SkuPriceLogs, QAQCFibreAnalysisEntity, QAQCFibreLabAnalysisEntity,ProductionInventory,QAQCProductCountsEntity
      ],
      // synchronize: mastersConfigs.sync,
      synchronize: false,
      logging: true,
      // logger: new QueryLogger(new PinoLogger({ pinoHttp: { level: mastersConfigs.loggingMode } })),/
    }
    ),
        RawMaterialGrnModule, IndentModule, RmIndentQtyLimitModule,RmCountPriceListModule,BaleModule,WorkOrderModule, QaqcModule],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule { }
